<div class="nav-items-group">
  <ng-content />
</div>
